// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICarrierIdPropertyDto } from './ICarrierIdPropertyDto';
import {
    ICarrierIdPropertyDtoFromJSON,
    ICarrierIdPropertyDtoFromJSONTyped,
    ICarrierIdPropertyDtoToJSON,
    ICarrierIdPropertyDtoToJSONTyped,
} from './ICarrierIdPropertyDto';
import type { INamePropertyDto } from './INamePropertyDto';
import {
    INamePropertyDtoFromJSON,
    INamePropertyDtoFromJSONTyped,
    INamePropertyDtoToJSON,
    INamePropertyDtoToJSONTyped,
} from './INamePropertyDto';
import type { IDeductiblesByServiceTypePropertyDto } from './IDeductiblesByServiceTypePropertyDto';
import {
    IDeductiblesByServiceTypePropertyDtoFromJSON,
    IDeductiblesByServiceTypePropertyDtoFromJSONTyped,
    IDeductiblesByServiceTypePropertyDtoToJSON,
    IDeductiblesByServiceTypePropertyDtoToJSONTyped,
} from './IDeductiblesByServiceTypePropertyDto';
import type { IHealthPlanTypePropertyDto } from './IHealthPlanTypePropertyDto';
import {
    IHealthPlanTypePropertyDtoFromJSON,
    IHealthPlanTypePropertyDtoFromJSONTyped,
    IHealthPlanTypePropertyDtoToJSON,
    IHealthPlanTypePropertyDtoToJSONTyped,
} from './IHealthPlanTypePropertyDto';
import type { IPlanCategorySpendLimitDto } from './IPlanCategorySpendLimitDto';
import {
    IPlanCategorySpendLimitDtoFromJSON,
    IPlanCategorySpendLimitDtoFromJSONTyped,
    IPlanCategorySpendLimitDtoToJSON,
    IPlanCategorySpendLimitDtoToJSONTyped,
} from './IPlanCategorySpendLimitDto';
import type { IHealthPlanEnrollmentMatrixCreateDto } from './IHealthPlanEnrollmentMatrixCreateDto';
import {
    IHealthPlanEnrollmentMatrixCreateDtoFromJSON,
    IHealthPlanEnrollmentMatrixCreateDtoFromJSONTyped,
    IHealthPlanEnrollmentMatrixCreateDtoToJSON,
    IHealthPlanEnrollmentMatrixCreateDtoToJSONTyped,
} from './IHealthPlanEnrollmentMatrixCreateDto';
import type { IHealthPlanDeductibleConfigDto } from './IHealthPlanDeductibleConfigDto';
import {
    IHealthPlanDeductibleConfigDtoFromJSON,
    IHealthPlanDeductibleConfigDtoFromJSONTyped,
    IHealthPlanDeductibleConfigDtoToJSON,
    IHealthPlanDeductibleConfigDtoToJSONTyped,
} from './IHealthPlanDeductibleConfigDto';
import type { IIsAutoEnrollmentPropertyDto } from './IIsAutoEnrollmentPropertyDto';
import {
    IIsAutoEnrollmentPropertyDtoFromJSON,
    IIsAutoEnrollmentPropertyDtoFromJSONTyped,
    IIsAutoEnrollmentPropertyDtoToJSON,
    IIsAutoEnrollmentPropertyDtoToJSONTyped,
} from './IIsAutoEnrollmentPropertyDto';

/**
 * 
 * @export
 * @interface IHealthPlanUpdateDto
 */
export interface IHealthPlanUpdateDto {
    /**
     * 
     * @type {INamePropertyDto}
     * @memberof IHealthPlanUpdateDto
     */
    name?: INamePropertyDto;
    /**
     * 
     * @type {string}
     * @memberof IHealthPlanUpdateDto
     */
    plan_code?: string;
    /**
     * 
     * @type {string}
     * @memberof IHealthPlanUpdateDto
     */
    plan_status?: IHealthPlanUpdateDtoPlanStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof IHealthPlanUpdateDto
     */
    plan_year_id?: number;
    /**
     * 
     * @type {IHealthPlanTypePropertyDto}
     * @memberof IHealthPlanUpdateDto
     */
    health_plan_types?: IHealthPlanTypePropertyDto;
    /**
     * 
     * @type {IDeductiblesByServiceTypePropertyDto}
     * @memberof IHealthPlanUpdateDto
     */
    deductibles_by_service_type?: IDeductiblesByServiceTypePropertyDto;
    /**
     * 
     * @type {ICarrierIdPropertyDto}
     * @memberof IHealthPlanUpdateDto
     */
    carrier_id?: ICarrierIdPropertyDto;
    /**
     * 
     * @type {IIsAutoEnrollmentPropertyDto}
     * @memberof IHealthPlanUpdateDto
     */
    is_auto_enrollment?: IIsAutoEnrollmentPropertyDto;
    /**
     * 
     * @type {Set<IHealthPlanDeductibleConfigDto>}
     * @memberof IHealthPlanUpdateDto
     */
    health_plan_deductible_configs?: Set<IHealthPlanDeductibleConfigDto>;
    /**
     * 
     * @type {number}
     * @memberof IHealthPlanUpdateDto
     */
    organization_id?: number;
    /**
     * 
     * @type {IHealthPlanEnrollmentMatrixCreateDto}
     * @memberof IHealthPlanUpdateDto
     */
    enrollment_matrix?: IHealthPlanEnrollmentMatrixCreateDto;
    /**
     * 
     * @type {string}
     * @memberof IHealthPlanUpdateDto
     */
    summary?: string;
    /**
     * 
     * @type {string}
     * @memberof IHealthPlanUpdateDto
     */
    notes?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IHealthPlanUpdateDto
     */
    per_person_spend_limit?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IHealthPlanUpdateDto
     */
    per_category_spend_limit?: boolean;
    /**
     * 
     * @type {Array<IPlanCategorySpendLimitDto>}
     * @memberof IHealthPlanUpdateDto
     */
    category_spend_limits?: Array<IPlanCategorySpendLimitDto>;
    /**
     * 
     * @type {Set<number>}
     * @memberof IHealthPlanUpdateDto
     */
    plans?: Set<number>;
}

/**
* @export
* @enum {string}
*/
export enum IHealthPlanUpdateDtoPlanStatusEnum {
    DRAFT = 'DRAFT',
    ACTIVE = 'ACTIVE',
    UNDER_UPDATE = 'UNDER_UPDATE'
}


/**
 * Check if a given object implements the IHealthPlanUpdateDto interface.
 */
export function instanceOfIHealthPlanUpdateDto(value: object): value is IHealthPlanUpdateDto {
    return true;
}

export function IHealthPlanUpdateDtoFromJSON(json: any): IHealthPlanUpdateDto {
    return IHealthPlanUpdateDtoFromJSONTyped(json, false);
}

export function IHealthPlanUpdateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IHealthPlanUpdateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : INamePropertyDtoFromJSON(json['name']),
        'plan_code': json['plan_code'] == null ? undefined : json['plan_code'],
        'plan_status': json['plan_status'] == null ? undefined : json['plan_status'],
        'plan_year_id': json['plan_year_id'] == null ? undefined : json['plan_year_id'],
        'health_plan_types': json['health_plan_types'] == null ? undefined : IHealthPlanTypePropertyDtoFromJSON(json['health_plan_types']),
        'deductibles_by_service_type': json['deductibles_by_service_type'] == null ? undefined : IDeductiblesByServiceTypePropertyDtoFromJSON(json['deductibles_by_service_type']),
        'carrier_id': json['carrier_id'] == null ? undefined : ICarrierIdPropertyDtoFromJSON(json['carrier_id']),
        'is_auto_enrollment': json['is_auto_enrollment'] == null ? undefined : IIsAutoEnrollmentPropertyDtoFromJSON(json['is_auto_enrollment']),
        'health_plan_deductible_configs': json['health_plan_deductible_configs'] == null ? undefined : (new Set((json['health_plan_deductible_configs'] as Array<any>).map(IHealthPlanDeductibleConfigDtoFromJSON))),
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'enrollment_matrix': json['enrollment_matrix'] == null ? undefined : IHealthPlanEnrollmentMatrixCreateDtoFromJSON(json['enrollment_matrix']),
        'summary': json['summary'] == null ? undefined : json['summary'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'per_person_spend_limit': json['per_person_spend_limit'] == null ? undefined : json['per_person_spend_limit'],
        'per_category_spend_limit': json['per_category_spend_limit'] == null ? undefined : json['per_category_spend_limit'],
        'category_spend_limits': json['category_spend_limits'] == null ? undefined : ((json['category_spend_limits'] as Array<any>).map(IPlanCategorySpendLimitDtoFromJSON)),
        'plans': json['plans'] == null ? undefined : new Set(json['plans']),
    };
}

export function IHealthPlanUpdateDtoToJSON(json: any): IHealthPlanUpdateDto {
    return IHealthPlanUpdateDtoToJSONTyped(json, false);
}

export function IHealthPlanUpdateDtoToJSONTyped(value?: IHealthPlanUpdateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': INamePropertyDtoToJSON(value['name']),
        'plan_code': value['plan_code'],
        'plan_status': value['plan_status'],
        'plan_year_id': value['plan_year_id'],
        'health_plan_types': IHealthPlanTypePropertyDtoToJSON(value['health_plan_types']),
        'deductibles_by_service_type': IDeductiblesByServiceTypePropertyDtoToJSON(value['deductibles_by_service_type']),
        'carrier_id': ICarrierIdPropertyDtoToJSON(value['carrier_id']),
        'is_auto_enrollment': IIsAutoEnrollmentPropertyDtoToJSON(value['is_auto_enrollment']),
        'health_plan_deductible_configs': value['health_plan_deductible_configs'] == null ? undefined : (Array.from(value['health_plan_deductible_configs'] as Set<any>).map(IHealthPlanDeductibleConfigDtoToJSON)),
        'organization_id': value['organization_id'],
        'enrollment_matrix': IHealthPlanEnrollmentMatrixCreateDtoToJSON(value['enrollment_matrix']),
        'summary': value['summary'],
        'notes': value['notes'],
        'per_person_spend_limit': value['per_person_spend_limit'],
        'per_category_spend_limit': value['per_category_spend_limit'],
        'category_spend_limits': value['category_spend_limits'] == null ? undefined : ((value['category_spend_limits'] as Array<any>).map(IPlanCategorySpendLimitDtoToJSON)),
        'plans': value['plans'] == null ? undefined : Array.from(value['plans'] as Set<any>),
    };
}

